// @flow

import { createSelector } from "reselect";
import { view } from "ramda";
import { type GridState, type State } from "../";
import { isModoSeries } from "./comum";
import { modoVisualizacaoSeries } from "./series";

import {
  gridFilterState,
  gridFixedLeftState,
  gridFixedRightState,
  gridGroupState,
  gridOrderState,
  gridSortState,
  gridState,
} from "../lenses";

export const getGridState: State => GridState = createSelector(
  isModoSeries,
  modoVisualizacaoSeries,
  view(gridState),
  (isSeries, formaDeVisualizacaoRelatorioSeries, grid) => {
    if (isSeries) {
      return {
        ...grid,
        formaDeVisualizacaoRelatorioSeries,
      };
    } else {
      return grid;
    }
  }
);
export const getGridStateSort = view(gridSortState);
export const getGridStateFilter = view(gridFilterState);
export const getGridStateGroup = view(gridGroupState);
export const getGridStateOrder = view(gridOrderState);
export const getGridStateFixedRight = view(gridFixedRightState);
export const getGridStateFixedLeft = view(gridFixedLeftState);
export const isGeneratingReport = (state: State): boolean =>
  state.gerandoRelatorio;
